function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" {...props}><path d="M23.436 27.019H8.565V12.418l-5.91.523V6.067l9.81-1.086.01.143c.17 2.286 1.71 4.01 3.585 4.01s3.415-1.722 3.585-4.006l.01-.143 9.691 1.082v6.874l-5.911-.528v14.606zM8.84 26.743h14.321V12.112l5.91.528V6.313L19.908 5.29c-.234 2.358-1.868 4.119-3.847 4.119s-3.615-1.763-3.847-4.123L2.93 6.313v6.327l5.91-.523v14.626z" /></svg>;
});